// React Imports
import * as React from 'react';
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import {Stack} from "@mui/material";

// App Imports
import {changeWorkQueue} from "../workQueueSlice";
import {changeContractStatsControls} from "../WorkStats/contractStatsControlsSlice";
import {changeContractSearch} from "../Contracts/contractSearchSlice";
import {changeWork} from "../../Work/workSlice";


// main function
export default function QueueMethodTabs(props) {
    const [methodTabValue, setMethodTabValue] = React.useState(1);

    const dispatchData = useDispatch();

    const selectorTabIndex = useSelector((state) => state.workSlc.value.workQueueMethodTabsIndex);



    const handleChange = (event, newValue) => {
        setMethodTabValue(newValue);
        console.log("handleChange triggered.")
        dispatchData(changeWorkQueue({selectedContractId: 0 , propertyDropdownTitleId: 0, bigAddButtonDisplay: false }));
        console.log("propertyDropdownTitleId modified to equal 0 ");
        if(newValue == 0){

            dispatchData(changeWork({workQueueMethodTabsIndex: 0}));
            dispatchData(changeWorkQueue({methodTabsState: true, propertySearchState: false, unstructuredSearchState: false,statsViewState: true}));
            dispatchData(changeContractStatsControls({gridDisplay: "MarketGroupContractStats"}));
            console.log("show property hierarchy");
        }
        if(newValue == 1){
            dispatchData(changeWork({workQueueMethodTabsIndex: 1}));
            dispatchData(changeWorkQueue({methodTabsState: true, propertySearchState: true, unstructuredSearchState: false,
                statsViewState: false, bigAddButtonDisplay: true}));
            console.log("show property tree search");
        }
        if(newValue == 2){
            dispatchData(changeWork({workQueueMethodTabsIndex: 2}));
            dispatchData(changeContractSearch({
                id: null,
                idFrom: null,
                idTo: null,
                contractType: null,
                mcode: null,
                name: null,
                craatedOn: null,
                createdFrom: null,
                createdTo: null,
                contractSearchGridRefresh: false
            }));
            dispatchData(changeWorkQueue({methodTabsState: true, propertySearchState: false,
                unstructuredSearchState: true,statsViewState: false, bigAddButtonDisplay: false}));
            console.log("show unstructured search");
        }

    };

    return (
        <Stack direction="row" spacing={2}>

            <Box sx={{pt: 2,  width: 400, height: 40, bgcolor: 'background.paper' }}>
                <Tabs value={selectorTabIndex}
                      defaultValue={selectorTabIndex}
                      onChange={handleChange} >
                    <Tab  label="Hierarchy"
/>
                    <Tab  label="By Property"
/>
                    <Tab  label="Unstructured"
/>
                </Tabs>
            </Box>
        </Stack>
    );
}
